const AdvancedInsights = () => import(/* webpackChunkName: "AdvancedInsights" */ 'Features/advancedInsights/Main');

const AdvancedInsightsRoute =  {
  name: 'advancedInsights',
  path: 'advancedInsights',
  component: AdvancedInsights,
  meta: {
    requiresAuth: true,
    title: 'message.advancedInsights.name',
    breadcrumb: 'message.advancedInsights.name'
  }
}

export default AdvancedInsightsRoute;
